export default {
  repoURL: import.meta.env.REPO_URL,
  baseUrl: import.meta.env.BASE_URL_PATH,
};
